import React, {Component} from "react";
import {Col, Container, Row} from "react-bootstrap";
import CareerStats from "./CareerStats";
import PlayedPositionMap from "./PlayedPositionMap";
import PerformanceAndSkillsScore from "./PerformanceAndSkillsScore";
import TeamAndTransfer from "./TeamAndTransfer";

class PlayerDetails extends Component {
    render = () => {
        return this.renderContent();
    };

    renderVerticalLine = () => {
        return (
            <div className="vertical-line d-lg-none d-xl-block"/>
        );
    };

    renderContent = () => {
        const {page, careerStats, performance, transfers, positions} = this.props;

        return (
            <div className="player-details">
                <Container fluid={true}>
                    <Row>
                        <Col xl={2} lg={6} md={12}>
                            <CareerStats data={careerStats} page={page}/>
                        </Col>
                        <Col sm={"auto"}>
                            {this.renderVerticalLine()}
                        </Col>
                        <Col xl={"auto"} lg={6} md={12} className="played-position-map-column">
                            <PlayedPositionMap data={positions}/>
                        </Col>
                        <Col sm={"auto"}>
                            {this.renderVerticalLine()}
                        </Col>
                        <Col xl={5} lg={6} md={12}>
                            <PerformanceAndSkillsScore data={performance}/>
                        </Col>
                        <Col sm={"auto"}>
                            {this.renderVerticalLine()}
                        </Col>
                        <Col xl={2} lg={6} md={12}>
                            <TeamAndTransfer data={transfers}/>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    };
}

export default PlayerDetails;
